export const getFirstInitial = str => str ? str[0].toUpperCase():null;

export const isEmptyValue = (val) => val === '' || val === null || val === undefined;

export const stringToCnpj = (v) => {
  if (!v || v.length === 0) return '__.___.___/____-__';
  if (v.length === 14) return `${v.slice(0,2)}.${v.slice(2,5)}.${v.slice(5,8)}/${v.slice(8,12)}-${v.slice(-2)}`;
  return v;
}